<template>
    <div>
        <kgr-signature-pad :on-finished="onFinished" />
        <input
            type="hidden"
            name="signature"
            :value="image"
        />
    </div>
</template>

<script>

import SignaturePad from '../../service/SignaturePad';

export default {
    name: 'ChildRegistrationSignaturePad',
    components: {
        'kgr-signature-pad': SignaturePad,
    },
    data() {
        return {
            image: '',
        }
    },
    methods: {
        onFinished(image) {
            this.image = image;
        }
    }
}
</script>

<style scoped>

</style>